import { render, staticRenderFns } from "./DeleteChatDialog.vue?vue&type=template&id=df49225a&scoped=true"
import script from "./DeleteChatDialog.vue?vue&type=script&lang=js"
export * from "./DeleteChatDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteChatDialog.vue?vue&type=style&index=0&id=df49225a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df49225a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
